<!-- Start of Quick search common component -->
  <app-quick-search 
    [DefaultFilterArray]="odrReportsService.defaultFilterArray"
    [QuickSearchFilterArray]="quickFilterArray"
    (updateDefaultArray)="updateDefaultArray($event)"
    (clearQuickSearch)="clearQuickSearch($event)">
  </app-quick-search>
<!-- end of Quick search common component -->

<p-confirmDialog 
  acceptLabel="Ok" 
  key="informationDialoge" 
  [rejectVisible]="true" 
  appendTo="body" 
  header="Information" 
  icon="pi pi-exclamation-triangle" 
  [baseZIndex]="999999"
  styleClass="confirm-dialog">
</p-confirmDialog>

<!--Filter Code  -->
<div class="col-lg-12 nopadding">
    <app-filter-panel  id="VenueRateFilter" [GridColumns]="columns" [DefaultFilterArray]="odrReportsService.defaultFilterArray"
    (FilterEvent)="FilterApplyFilterEvent($event)">
  </app-filter-panel>
</div>

<!-- Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(odrReportsService.isLoadingResults){
    <div class="example-loading-shade">
    @if(odrReportsService.isLoadingResults){<mat-spinner></mat-spinner>}
    </div>}
    <p-table 
      id="odrReportsTable"
      alwaysShowPaginator="true" 
      paginatorPosition="both" 
      showCurrentPageReport="true"
      [value]="odrReportsService.dataset" 
      [columns]="gridColumns" 
      [resizableColumns]="true" 
      columnResizeMode="expand"
      [(selection)]="selectedRow"
      [paginator]="true"
      appendTo="body"
      (onPage)="changePage($event)"
      (onSort)="sort($event)"
      sortMode="multiple"
      [rows]="constantService.DEFAULT_ROWSIZE" 
      [totalRecords]="odrReportsService.totalRecords" 
      [pageLinks]="constantService.DEFAULT_PAGELINKS"
      [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION"  
      [lazy]="true" 
      [scrollable]="true" 
      scrollHeight="60vh"
      styleClass="tableData destinationDetailsTable"
      #dt>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            {{emptytbldatamsg}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of columns; track col;){
          <th id="columns" pResizableColumn [pSortableColumn]="col.field"
            [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
            {{col.header}}
            @if((col.header | lowercase) !== 'action'){
            <p-sortIcon [field]="col.field"></p-sortIcon>}
          </th>}
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="ri" let-ri="rowIndex">
        <tr [pSelectableRow]="row" [pSelectableRowIndex]="ri"
          [ngClass]="(row['action'] | lowercase) == 'd' ? 'ui-widget-deleted-row' : 'ui-widget-NoUpdated-row'">
          @for (col of columns; track col;){
            <td class="ui-resizable-column"
            [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay' : '' ">
            @if(col.header === 'Action'){
              <span>
                @if(row['reportStatus'] !== 'DECLINED'){
              <p-button [id]="'ApproveBtn'+row['id']" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Approve" matTooltipPosition="above"
                appendTo="body" icon="fa fa-xxx fa-check" (click)="onApprove(ri,row);"></p-button>
                }
                @if(row['reportStatus'] == 'GENERATED' || row['reportStatus'] == 'DECLINED'){
              <p-button [id]="'DeclineBtn'+row['id']"   class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Decline" matTooltipPosition="above"
                appendTo="body" icon="fa fa-xxx fa-times" (click)="onDecline(ri,row);"></p-button>
                }
                <p-button [id]="'DownloadBtn'+ row['id']" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Download" 
                appendTo="body" icon="fa fa-download" (click)="downloadReport(ri,row)" styleClass="downloadFile"></p-button>
                @if(row['reportStatus'] == 'GENERATED' || row['reportStatus'] == 'DECLINED'){
                <p-button [id]="'DeleteBtn'+row['id']"  class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" matTooltipPosition="above"
                  appendTo="body" icon="fa fa-xxx fa-trash" (click)="onDelete(ri,row)"></p-button>
                }
            </span>}
             <!-- set String -->
              @if(col.header != 'Action' && col.datatype !='Date'){
             <span>
                {{row[col.field] }}
            </span>}
            <!-- set Date -->
             @if(col.header != 'Action' && col.datatype=='Date'){
            <span>
                {{row[col.field] | date:'yyyy/MM/dd h:mm:ss'}}
            </span>}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorright">
        <button id="btn_approve_report"  type="button" class="pull-left cls-button" matTooltip="Generate Report"  [matTooltipShowDelay]="1000" class="exportBtn exportApproveBtn" (click)="genrateReport()">Generate Report</button>
        <button  [matTooltip]="this.userService.enableFileExport()?
                    'Export':'Export service is disabled'"
                     [matTooltipShowDelay]="1000" id="btn_report_export" class="exportBtn"
        (click)="exportToCSV()" type="button">Export  <i class="fa fa-download" aria-hidden="true"></i> 
        @if(isExportToCSV){
        <img style="text-align:right" alt="exportToCSV"
        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
        }</button>
        Total Records: {{odrReportsService.dataset.length == 0 ? 0 :odrReportsService.totalRecords}}
      </ng-template>
      <ng-template pTemplate="paginatorleft">
        Showing {{odrReportsService.dataset.length == 0 ? 0 : startLimit + 1}} to {{odrReportsService.dataset.length
         < odrReportsService.rowcount ? odrReportsService.dataset.length < startLimit ? endLimit :
 odrReportsService.dataset.length : endLimit}} entries </ng-template>
  </p-table>
  <br>
  <br>
</div>
@if(showDialog){
  <app-add-edit-view-odr-reports [showDialog]="showDialog" (visibilityChange)="showDialog = $event"></app-add-edit-view-odr-reports>
}
@if(isDisplayCommentViewer){
  <app-add-edit-view-odr-reports (visibilityChange)="isDisplayCommentViewer = $event" [selectedRowIndex]="selectedRowIndex" [comment]="selectedRow.comments"
  [isDisplayCommentViewer]="isDisplayCommentViewer" [selectedRow]="selectedRow" [isApprove]="isApprove" [isDecline]="isDecline"></app-add-edit-view-odr-reports>
}